/*
  Vistos Recentemente

  Guarda no navegador (localStorage) apenas os IDs dos produtos visitados,
  nunca o HTML: assim preço, promoção e disponibilidade vêm sempre frescos
  da Shopify na hora de montar a vitrine.

  Como os cards são obtidos: uma única requisição para a Search API pedindo
  a própria seção renderizada (?section_id=), o que garante exatamente o
  mesmo componente visual de "Você também pode gostar".
*/
(() => {
  const CHAVE = 'cdr:vistos-recentemente';
  const LIMITE_ARMAZENADO = 20;

  function ler() {
    try {
      const cru = localStorage.getItem(CHAVE);
      const lista = cru ? JSON.parse(cru) : [];
      return Array.isArray(lista) ? lista.filter((n) => Number.isFinite(Number(n))).map(Number) : [];
    } catch (e) {
      return [];
    }
  }

  function gravar(lista) {
    try {
      localStorage.setItem(CHAVE, JSON.stringify(lista.slice(0, LIMITE_ARMAZENADO)));
    } catch (e) {
      /* modo privado ou cota cheia: seguir sem quebrar a página */
    }
  }

  /* registra a visita: sem repetir e sempre jogando o produto para o começo */
  function registrar(id) {
    if (!id) return;
    const lista = ler().filter((x) => x !== id);
    lista.unshift(id);
    gravar(lista);
  }

  async function montar(secao) {
    const idAtual = Number(secao.dataset.produtoAtual) || 0;
    const maximo = Number(secao.dataset.maximo) || 8;

    const ids = ler().filter((id) => id !== idAtual).slice(0, maximo);
    if (!ids.length) return;

    const consulta = ids.map((id) => 'id:' + id).join(' OR ');
    const url =
      window.Shopify.routes.root +
      'search?type=product&options[unavailable_products]=last&q=' +
      encodeURIComponent(consulta) +
      '&section_id=' +
      secao.dataset.sectionId;

    let html;
    try {
      const resposta = await fetch(url);
      if (!resposta.ok) return;
      html = await resposta.text();
    } catch (e) {
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const pronto = doc.querySelector('[data-vistos-conteudo]');
    if (!pronto) return;

    const trilho = pronto.querySelector('.cdrlc__track');
    if (!trilho || !trilho.children.length) return;

    /* a busca devolve por relevância; aqui volta para a ordem de visita */
    const slides = Array.from(trilho.children);
    slides
      .slice()
      .sort((a, b) => ids.indexOf(Number(a.dataset.produtoId)) - ids.indexOf(Number(b.dataset.produtoId)))
      .forEach((s) => trilho.appendChild(s));

    /* o produto aberto agora nunca entra na vitrine */
    slides.forEach((s) => {
      if (Number(s.dataset.produtoId) === idAtual) s.remove();
    });
    if (!trilho.children.length) return;

    const destino = secao.querySelector('[data-vistos-destino]');
    if (!destino) return;
    destino.replaceChildren(document.importNode(pronto, true));
    secao.hidden = false;
  }

  function iniciar(raiz) {
    (raiz || document).querySelectorAll('[data-vistos-secao]').forEach((secao) => {
      if (secao.dataset.vistosPronto === 'true') return;
      secao.dataset.vistosPronto = 'true';
      montar(secao);
    });
  }

  /* 1) registra a visita da página atual */
  const marcador = document.querySelector('[data-vistos-registrar]');
  if (marcador) registrar(Number(marcador.dataset.vistosRegistrar));

  /* 2) monta a vitrine */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => iniciar(), { once: true });
  } else {
    iniciar();
  }

  /* editor de tema: a seção volta do servidor zerada, então remonta */
  document.addEventListener('shopify:section:load', (evento) => {
    iniciar(evento.target);
  });
})();
